import { render, staticRenderFns } from "./RequiredLabel.vue?vue&type=template&id=7a2dba5e&scoped=true&"
import script from "./RequiredLabel.vue?vue&type=script&lang=js&"
export * from "./RequiredLabel.vue?vue&type=script&lang=js&"
import style0 from "./RequiredLabel.vue?vue&type=style&index=0&id=7a2dba5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2dba5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
